// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__WZ7uo","title":"BackImages_title__2XidU","images":"BackImages_images__3SHuA"};